var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReady),expression:"isReady"}],ref:"container",staticClass:"resizer-container",class:{
    resizing: _vm.resizing,
  },style:(_vm.cssVars)},[_c('main',{staticClass:"main",on:{"mousedown":_vm.mouseDownDrag}},[_vm._t("default")],2),_c('div',{staticClass:"resizers",class:( _obj = {}, _obj['show-for-dev'] = _vm.resizer.showForDev, _obj.shrinkable = _vm.resizer.shrinkable, _obj )},_vm._l((_vm.resizer.parts),function(ref,key){
    var className = ref.className;
return _c('div',{key:key,class:("" + className),on:{"mousedown":function (event) { return _vm.mouseDownResize(event, key); }}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }